export class IngredientSideEffectContentModel {
    public ingredientSideEffectId: number;
    public langId: number;
    public summary: string;
    public consumerDescription: string;
    public overdoseDescription: string;
    public professionalDescription: string;
    public otherInformation: string;
}